import $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { DemandeParamTransfertDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeParamTransfertDto";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { NatureTransfertEnum } from "../../dto/GenApi.iNotPaie.Dto/NatureTransfertEnum";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { RubriqueDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import dateHelper from "../../Helper/dateHelper";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalAjoutUpdateScenario from "./modalAjoutUpdateScenario/modalAjoutUpdateScenario";

@Component({
    components: {
        ModalAjoutUpdateScenario: require("./modalAjoutUpdateScenario/modalAjoutUpdateScenario.vue.html")
    },
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as ScenarioComponent);
            vm.getParametres();
        });
    }
})
export default class ScenarioComponent extends Vue {
    public scenarios: ParametreDto[] = [];
    public scenariosFiltred: ParametreDto[] = [];
    public typesScenario: ParametreDto[] = [];
    public listeRubriques: RubriqueDto[] = [];

    public currentOrderColumn = "Libelle";
    public orderingDesc = true;

    public filterTypeScenario = "RETRO";
    public filterName = "";

    public dataReady = false;
    public displayArchives = false;
    public canDoTransfert = false;

    public modalAjoutUpdateScenario?: ModalAjoutUpdateScenario = undefined;

    public getParametres(): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }
        ServicesFactoryInstance.ScenariosService.getScenarios(data => {
            this.scenarios = data;
            this.scenariosFiltred = this.scenarios;
            this.listeRubriques = ParametresInstance.listeRubriques;
            ServicesFactoryInstance.ScenariosService.getTypesScenarios(data => {
                this.typesScenario = data;
            });

            this.canDoTransfert = ParametresInstance.userIsCombinedAuthorized(["Administrateur", "AdministrateurPST"])
                && FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.TransfertSql);

            this.getClassOfOrder(this.currentOrderColumn, true);
            this.doFilter();
            this.dataReady = true;
        });
    }

    public getClassOfOrder(columnName: string, desc: boolean): string {
        if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    public orderBy(columnName: string): void {
        if (this.currentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.currentOrderColumn = columnName;

        this.doOrder();
    }

    public doOrder(): void {
        const orderingDesc = this.orderingDesc;
        const columnName = this.currentOrderColumn;
        if (this.scenariosFiltred != undefined) {
            this.scenariosFiltred = this.scenariosFiltred.sort(function (a, b) {

                // Gestion des valeurs null
                if (a[columnName] === null) {
                    return 1;
                }

                if (b[columnName] === null) {
                    return -1;
                }

                if (a[columnName] < b[columnName]) {
                    return (orderingDesc ? -1 : 1);
                }
                if (a[columnName] > b[columnName]) {
                    return (orderingDesc ? 1 : -1);
                }

                return 0;
            });
        }
    }

    public doFilter(): void {
        if (this.filterName == undefined || this.filterName == "") {
            this.scenariosFiltred = this.scenarios.filter(s => this.filterTypeScenario == s.CodeCategorie &&
                this.displayArchives == s.EstArchive);
        } else {
            this.scenariosFiltred = this.scenarios.filter(s =>
                this.filterTypeScenario == s.CodeCategorie &&
                this.displayArchives == s.EstArchive &&
                (s.Libelle != undefined && (s.Libelle.toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                    (s.CodeCategorie != undefined && s.CodeCategorie.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0)));
        }
        this.doOrder();
    }

    public ajouter(): void {
        if (this.modalAjoutUpdateScenario == undefined) {
            this.modalAjoutUpdateScenario = this.$refs.modalAjoutUpdateScenario as ModalAjoutUpdateScenario;
        }

        if (this.modalAjoutUpdateScenario != undefined) {
            this.modalAjoutUpdateScenario.Init(this.listeRubriques, this.filterTypeScenario);
        }

        $("#modalAjoutUpdateScenario").modal("show");
    }

    public update(id: any): void {
        if (this.modalAjoutUpdateScenario == undefined) {
            this.modalAjoutUpdateScenario = this.$refs.modalAjoutUpdateScenario as ModalAjoutUpdateScenario;
        }

        if (this.modalAjoutUpdateScenario != undefined) {
            this.modalAjoutUpdateScenario.Init(this.listeRubriques, undefined, id);
        }

        $("#modalAjoutUpdateScenario").modal("show");
    }

    public archiverScenario(id: number): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment archiver ce scénario ?",
            callBackYes: () => {
                ServicesFactoryInstance.ScenariosService.archiverScenario(id, () => {
                    NotificationServiceInstance.SendSuccess("Scénario archivé avec succès.");
                    this.getParametres();
                });
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public openModaleTransfert(scenario: ParametreDto): void {
        const modalTransfert: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Cette action va envoyer votre élément vers la liste d'attente des transferts SQL. Souhaitez-vous continuer ?",
            showDialog: true,
            title: "Confirmation",
            callBackYes: () => {
                this.transfertScenario(scenario);
            }
        });

        EventBus.$emit(EventConstants.MODAL_ALERT, modalTransfert);
    }

    public transfertScenario(scenario: ParametreDto): void {
        if (scenario !== undefined && scenario.Code !== undefined && scenario.CodeCategorie !== undefined) {
            const demande: DemandeParamTransfertDto = {
                Code: scenario.Code,
                CodeCategorie: scenario.CodeCategorie,
                Nature: NatureTransfertEnum.Scenario
            };

            ServicesFactoryInstance.EntiteEnAttenteService.addParametreToList(demande, () => {
                NotificationServiceInstance.SendSuccess("L'élément <strong>" + scenario.Libelle + "</strong> a bien été ajouté à la liste d'attente des transferts SQL.");
                this.dataReady = false;
                this.getParametres();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/scenarios/scenarios.ts